import script from "./BrandedBusinessCard.vue?vue&type=script&setup=true&lang=js"
export * from "./BrandedBusinessCard.vue?vue&type=script&setup=true&lang=js"

import "./BrandedBusinessCard.vue?vue&type=style&index=0&id=7b2d3360&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b2d3360"]])

export default __exports__